import { render, staticRenderFns } from "./RoleManagementPage.vue?vue&type=template&id=b9cfb91e&scoped=true&"
import script from "./RoleManagementPage.vue?vue&type=script&lang=js&"
export * from "./RoleManagementPage.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagementPage.vue?vue&type=style&index=0&id=b9cfb91e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cfb91e",
  null
  
)

export default component.exports